/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface ShortNovelasClipsUiModuleBody
 */
export interface ShortNovelasClipsUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    moduleType: ShortNovelasClipsUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    copy: string;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    ctaText: string;
    /**
     * 
     * @type {string}
     * @memberof ShortNovelasClipsUiModuleBody
     */
    backgroundFillVideo: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ShortNovelasClipsUiModuleBodyModuleTypeEnum {
    SHORT_NOVELAS_CLIPS = 'SHORT_NOVELAS_CLIPS'
}



